import Keycloak from 'keycloak-js';

export const redirectUri = process.env.REACT_APP_REDIRECT_URI;
export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_BASE_URL;

export const keycloakConfig = {
  url: keycloakUrl,
  realm: 'cgrm',
  clientId: 'CGRM_MOBILE'
};

let keycloak; 
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
  if (!keycloak) {
     keycloak = new Keycloak(keycloakConfig);
  }
 try {
   
    keycloak
      .init({
        pkceMethod: 'S256',
        redirectUri: window.location.origin + window.location.pathname + window.location.search + window.location.hash, // Garder l'URL actuelle
        checkLoginIframe: false
      })
      .then(onAuthenticatedCallback)
      .catch(err => console.error('Keycloak initialization error:', err));
  } catch (error) {
    console.error('Error initializing Keycloak:', error);
  }
  
};

const doLogin = (opts = {}) => keycloak.login(opts);

const doLogout = () => keycloak.logout();

const getToken = () => keycloak.token;

const getTokenParsed = () => keycloak.tokenParsed;

const isLoggedIn = () => !!keycloak.token;

const isTokenExpireSoon = () => {
  if (isLoggedIn()) {
    const tokenParsed = keycloak.tokenParsed;
    const currentTime = Math.floor(Date.now() / 1000);
    if (!tokenParsed) {
      return false;
    }
    const tokenExpiryTime = tokenParsed.exp;
    const timeLeft = tokenExpiryTime - currentTime;

    return timeLeft <= 100;
  } else {
    return false;
  }
};
const updateToken = async () => {
  try {
    return await keycloak.updateToken(100);
  } catch (error) {
    doLogin();
  }
};

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  isTokenExpireSoon
};

export default KeycloakService;
 